import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Datatable } from "tw-elements";
import ErrorModal from "../Components/Common/ErrorModal";
import { ClearSession, SessionCheck } from "../Components/Common/Helper";
import * as Constants from "../Constants/constants";
import { TETabs, TETabsContent, TETabsItem, TETabsPane } from "tw-elements-react";
import { motion } from "framer-motion";
import { EnumTipoServico } from "../Model/Estimativa/EnumTipoServico";

/* INI: Configuração Grid */
/*const formatCell = (cell, value) => {
  cell.classList.add("font-semibold");
};*/

const gridOptions =
{
  bordered: true,
  hover: true,
  noFoundMessage: "Não foram encontrados serviços para esta categoria.",
  striped: true,
  fixedHeader: true,
  pagination: false,
  loading: true,
  selectable: false,
  multi: true
};

const dataServicos = {
  columns: [
    { label: '#', field: 'sequencial' },
    { label: 'Serviço', field: 'servico', sort: true, fixed: false },
    { label: 'Descrição', field: 'descricao', sort: true },
  ],
  rows: [
  ],
};
/* FIM: Configuração Grid */

export default function ComplementaryServices() {
  const navigate = useNavigate();
  const location = useLocation();
  // Session
  const sessionCheck = async () => { return await SessionCheck() };
  const clearSession = async () => { return await ClearSession() };


  /* INI: Objects */
  const servicoSelecionado = {
    inerente: null,
    complementar: null,
    acessorio: null,
    diverso: null
  }

  /* FIM: Objects */
  /* INI: States */
  const [verticalActive, setVerticalActive] = useState("inerentes");
  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }
    setVerticalActive(value);
  };
  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [servicoOptativo, setServicoOptativo] = useState({});
  const [servicoOptativoSelecionado, _setServicoSelecionado] = useState(servicoSelecionado);
  const [continuing, setContinuing] = useState(false);
  /* FIM: States */

  /* Refs */
  const tipoOperacaoDTO = useRef(location.state);
  const servicoSelecionadoRef = useRef(servicoOptativoSelecionado);
  const setServicoSelecionado = data => {
    let newData;
    let noRows = data.selectedRows.length == undefined || data.selectedRows.length === 0;

    if (data.srcElement.id === "tableInerentes")
      newData = { ...servicoSelecionadoRef.current, inerente: noRows ? null : data.selectedRows };

    if (data.srcElement.id === "tableComplementares")
      newData = { ...servicoSelecionadoRef.current, complementar: noRows ? null : data.selectedRows };

    if (data.srcElement.id === "tableAcessorios")
      newData = { ...servicoSelecionadoRef.current, acessorio: noRows ? null : data.selectedRows };

    if (data.srcElement.id === "tableDiversos")
      newData = { ...servicoSelecionadoRef.current, diverso: noRows ? null : data.selectedRows };

    servicoSelecionadoRef.current = newData;
    _setServicoSelecionado(newData);
  };
  /* FIM: Refs */

  /* INI: Funcs */
  const obterServicosOptativos = async (prTableInerentes, prTableComplementares, prTableAcessorios, prTableDiversos) => {
    const newErrors = {};
    try {
      const response = await fetch(
        Constants.ComplementaryServicesConstants.ENDPOINT_OBTERSERVICOSOPTATIVOS,
        { ...Constants.CommonConstants.DEFAULT_GET_REQUEST_OPTIONS }
      )

      const result = await response.json();
      if (result.success === true) {
        setServicoOptativo(result.responseObject);
        let naoAtualizado = { ...EnumTipoServico };

        Object.keys(result.responseObject).forEach((item) => {
          if (result.responseObject[item] != undefined) {
            let options = { ...gridOptions, loading: false, selectable: true };
            let data = { ...dataServicos, rows: result.responseObject[item] };

            switch (result.responseObject[item][0].tipo) {
              case EnumTipoServico.InerenteOptativo:
                prTableInerentes.update(data, options);
                delete naoAtualizado.InerenteOptativo;
                break;
              case EnumTipoServico.Complementar:
                prTableComplementares.update(data, options);
                delete naoAtualizado.Complementar;
                break;
              case EnumTipoServico.Acessorio:
                prTableAcessorios.update(data, options);
                delete naoAtualizado.Acessorio;
                break;
              case EnumTipoServico.Diverso:
                prTableDiversos.update(data, options);
                delete naoAtualizado.Diverso;
                break;
              default:
                break;
            }
          }
        });

        Object.keys(naoAtualizado).forEach(item => {
          switch (item) {
            case EnumTipoServico.InerenteOptativo:
              prTableInerentes.update({ ...dataServicos }, { ...gridOptions, loading: false });
              break;
            case EnumTipoServico.Complementar:
              prTableComplementares.update({ ...dataServicos }, { ...gridOptions, loading: false });
              break;
            case EnumTipoServico.Acessorio:
              prTableAcessorios.update({ ...dataServicos }, { ...gridOptions, loading: false });
              break;
            case EnumTipoServico.Diverso:
              prTableDiversos.update({ ...dataServicos }, { ...gridOptions, loading: false });
              break;
            default:
              break;
          }
        }
        );

      }
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
        if (result.technicalMessage.startsWith("No session"))
          navigate('/StartSimulation');
      }

    }
    catch (error) {
      newErrors.result = "Não foi possível obter os serviços optativos, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }

  }
  /* FIM: Funcs */

  /* INI:  Effect */
  const [sessionChecked, setSessionChecked] = useState(false);
  useEffect(() => {
    sessionCheck().then(value => {
      if (value) {
        setSessionChecked(true);
        
      }
      else {
        navigate('/StartSimulation')
      }
    });

    if (sessionChecked) {
      // Tw elements init
      const init = async () => {
        const { Datatable, initTE } = await import("tw-elements");
        initTE({ Datatable }, { allowReinits: true });
      }
      init();

      // Datatables init
      const tableInerentes = new Datatable(document.getElementById('tableInerentes'));
      tableInerentes.update({ ...dataServicos }, gridOptions);

      const tableComplementares = new Datatable(document.getElementById('tableComplementares'));
      tableComplementares.update({ ...dataServicos }, gridOptions);

      const tableAcessorios = new Datatable(document.getElementById('tableAcessorios'));
      tableAcessorios.update({ ...dataServicos }, gridOptions);

      const tableDiversos = new Datatable(document.getElementById('tableDiversos'));
      tableDiversos.update({ ...dataServicos }, gridOptions);

      // Populates datatables 
      obterServicosOptativos(tableInerentes, tableComplementares, tableAcessorios, tableDiversos);

      /* INI: Event listeners */
      const handleRowSelected = (e) => {
        setServicoSelecionado(e);
      };

      window.addEventListener("selectRows.te.datatable", handleRowSelected);
      return () => {
        window.removeEventListener("selectRows.te.datatable", handleRowSelected);
      };
      /* FIM: Event listeners */
    }
  }, [sessionChecked]);
  /* FIM:  Effect */

  const calcularServicosOptativos = async (prBody) => {
    const newErrors = {};
    try {
      setContinuing(true);
      const response = await fetch(
        Constants.ComplementaryServicesConstants.ENDPOINT_CALCULARSERVICOSOPTATIVOS,
        { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS, body: prBody }
      )

      const result = await response.json();
      if (result.success === true) {
        navigate('/FinalResult', { state: tipoOperacaoDTO.current });
      }
      else {
        newErrors.result = result.userFriendlyMessage;
        console.log(result.technicalMessage);
        if (result.technicalMessage.startsWith("No session"))
          navigate('/StartSimulation');
      }

    }
    catch (error) {
      newErrors.result = "Não foi possível calcular os serviços optativos, tente novamente mais tarde.";
      console.log(error);
    }
    finally {
      setContinuing(false);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowErrorModal(true);
      }
    }

  }
  /* INI: Handlers */

  async function handleCancelarClick(e) {
    e.preventDefault();
    await clearSession();
    navigate('/StartSimulation');
  }

  function handleContinuarClick(e) {
    e.preventDefault();
    let servicoList = [];
    Object.keys(servicoOptativoSelecionado).forEach((servicoTipoSelecionado) => {
      if (servicoOptativoSelecionado[servicoTipoSelecionado] != undefined) {
        servicoOptativoSelecionado[servicoTipoSelecionado].forEach((servicoSelecionado) => {
          if (servicoSelecionado != undefined) {
            Object.keys(servicoOptativo).forEach((servicoTipoOriginal) => {
              let servico = servicoOptativo[servicoTipoOriginal].find(servicoOriginal =>
                servicoOriginal.sequencial === servicoSelecionado.sequencial
              );
              if (servico != undefined)
                servicoList.push(servico);
            })
          }
        })
      }
    });
    let requestBody = null;
    if (servicoList.length > 0) {
      requestBody = JSON.stringify(servicoList);
    }
    calcularServicosOptativos(requestBody);
  };

  /* FIM: Handlers */
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {sessionChecked &&
        <div className="items-center">
          <div className="container mx-auto pt-4 pb-4  lg:px-6 bg-white">
            <section>
              <div className="flex flex-wrap items-start justify-center">
                <div className="w-full shrink-0 grow-0 basis-auto lg:w-5/6 xl:w-4/6 px-3 mb-5">
                  <h2 className="text-3xl font-bold">3. Escolha os</h2>
                  <h2 className="text-orange-600 mb-1 text-3xl font-bold">serviços optativos:</h2>
                  <p className="text-gray-500 sm:max-w-md">
                    Serviços optativos podem ser escolhidos por você. Estes são adicionais aos serviços compulsórios, os
                    quais são indispensáveis à atividade portuária e já estarão adicionados na simulação final.
                  </p>

                </div>
              </div>
              {/* Tabs NEW */}
              <div className="flex flex-wrap items-center justify-center">
                <TETabs vertical={false} fill justify className="w-full lg:w-5/6 xl:w-4/6">
                  <TETabsItem
                    onClick={() => handleVerticalClick("inerentes")}
                    active={verticalActive === "inerentes"}
                  >
                    Inerentes
                  </TETabsItem>
                  <TETabsItem
                    onClick={() => handleVerticalClick("complementares")}
                    active={verticalActive === "complementares"}
                  >
                    Complementares
                  </TETabsItem>
                  <TETabsItem
                    onClick={() => handleVerticalClick("acessorios")}
                    active={verticalActive === "acessorios"}
                  >
                    Acessórios
                  </TETabsItem>
                  <TETabsItem
                    onClick={() => handleVerticalClick("diversos")}
                    active={verticalActive === "diversos"}
                  >
                    Diversos
                  </TETabsItem>
                </TETabs>

                <TETabsContent className="flex flex-col overflow-x-auto items-center justify-center w-full lg:w-5/6 xl:w-4/6">
                  <TETabsPane show={verticalActive === "inerentes"} className="inline-block !w-full ">
                    <div
                      id="tableInerentes"
                      className="border-t border-gray-900/10 pb-2 !overflow-x-auto max-h-80"
                    >
                    </div>
                  </TETabsPane>
                  <TETabsPane show={verticalActive === "complementares"} className="inline-block !w-full">
                    <div
                      id="tableComplementares"
                      className="border-t border-gray-900/10 pb-2 mt-2  !overflow-x-auto max-h-80"
                    >
                    </div>
                  </TETabsPane>
                  <TETabsPane show={verticalActive === "acessorios"} className="inline-block !w-full">
                    <div
                      id="tableAcessorios"
                      className="border-t border-gray-900/10 pb-2 mt-2 !overflow-x-auto !overflow-y-auto max-h-80 "
                    >
                    </div>
                  </TETabsPane>
                  <TETabsPane show={verticalActive === "diversos"} className="inline-block !w-full">
                    <div
                      id="tableDiversos"
                      className="border-t border-gray-900/10 pb-2 mt-2 !overflow-x-auto max-h-80"
                    >
                    </div>
                  </TETabsPane>
                </TETabsContent>
              </div>

              <div className="mt-6 flex items-center justify-end gap-x-6 sm:w-full lg:w-11/12 xl:w-5/6">
                <button type="button" onClick={handleCancelarClick} className="text-sm font-semibold leading-6 text-gray-900">Cancelar</button>
                <button
                  type="submit"
                  onClick={handleContinuarClick}
                  className="rounded-md bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  {continuing ? "Aguarde..." : "Continuar"}
                  {continuing && <svg id="spinner" aria-hidden="true" class="inline ml-1 w-4 h-4 text-gray-200 animate-spin  fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                  </svg>}
                </button>
              </div>
            </section>
            <ErrorModal open={showErrorModal} onOpen={() => setShowErrorModal(false)} children={errors} />
          </div>
        </div>
      }
    </motion.div>
  );
}